import { render, staticRenderFns } from "./BigChip.vue?vue&type=template&id=d507862c&scoped=true&"
import script from "./BigChip.vue?vue&type=script&lang=js&"
export * from "./BigChip.vue?vue&type=script&lang=js&"
import style0 from "./BigChip.vue?vue&type=style&index=0&id=d507862c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d507862c",
  null
  
)

export default component.exports